import { ADULTS, CABIN_CLASS, CHILDREN, DEPARTURE_PORT, DESTINATION, NIGHTS, SHIP, START_DATE } from 'contexts/CruiseSearchContext/constants';

export const mapCriteriaToQuery = ({ criteria }) => {
	const listCriteria = Array.isArray(criteria) ? criteria : [];
	const result = listCriteria.map((val) => {
		const { ship = [], startDate = [], destination = [], departurePort = [], cabinClass = [], nights = [], adults = [], children = [] } = val;
		const queryDate = startDate.map((date) => {
			const startDate = date.start.split('T')[0];
			const endDate = date.end.split('T')[0];
			return `${startDate}~${endDate}`;
		});

		const params = [];
		const addParam = (params, param, key) => {
			const hadParam = param.length > 0;
			if (hadParam) {
				params.push(`${key}:${param.join(',')}`);
			}
		};

		addParam(params, ship, SHIP);
		addParam(params, queryDate, START_DATE);
		addParam(params, destination, DESTINATION);
		addParam(params, departurePort, DEPARTURE_PORT);
		addParam(params, cabinClass, CABIN_CLASS);
		addParam(params, nights, NIGHTS);
		addParam(params, adults, ADULTS);
		addParam(params, children, CHILDREN);

		return params.length > 0 ? params.join('|') : undefined;
	});
	return result.filter((val) => val !== undefined).join('||');
};
